import { Color } from './colors'


// dies ist die Farbmartrix. Welche Komponente kann welche Farbe haben.

const ExoGehaeuse = [Color.TITAN, Color.SCHWARZ, Color.KÖNIGSBLAU, Color.SMARAGDGRUEN, Color.INDIGO, Color.AMBER]
const Zifferblatt = [Color.TITAN, Color.SCHWARZ, Color.KÖNIGSBLAU, Color.SMARAGDGRUEN, Color.INDIGO, Color.AMBER]
const SekRing = [Color.TITAN, Color.SCHWARZ, Color.KÖNIGSBLAU, Color.SMARAGDGRUEN, Color.INDIGO, Color.AMBER]
const SekZeiger = [Color.TITAN, Color.SCHWARZ, Color.KÖNIGSBLAU, Color.SMARAGDGRUEN, Color.FEUERROT, Color.INDIGO, Color.AMBER]
const Krone = [Color.TITAN, Color.SCHWARZ]
const RotorWaben = [Color.TITAN, Color.SCHWARZ, Color.KÖNIGSBLAU, Color.SMARAGDGRUEN, Color.INDIGO, Color.AMBER]
const Werkhaltering = [Color.TITAN, Color.SCHWARZ, Color.KÖNIGSBLAU, Color.SMARAGDGRUEN, Color.INDIGO, Color.AMBER]
const Schrauben = [Color.TITAN, Color.SCHWARZ, Color.KÖNIGSBLAU, Color.SMARAGDGRUEN, Color.INDIGO, Color.AMBER]

const Band = [Color.TITAN_GRAU, Color.SCHWARZ, Color.KÖNIGSBLAU, Color.SMARAGDGRUEN, Color.OLIVGRÜN, Color.INDIGO, Color.ORANGE]
const Naht = [Color.TITAN_GRAU, Color.SCHWARZ, Color.KÖNIGSBLAU, Color.SMARAGDGRUEN, Color.OLIVGRÜN, Color.FEUERROT, Color.INDIGO, Color.ORANGE]

 export{Band,ExoGehaeuse,Krone,Naht,SekRing,SekZeiger,Zifferblatt,RotorWaben,Schrauben,Werkhaltering}